import { getENV } from './env';
import { getOrigin } from './getOrigin';

/**
 * Resolves the storefront origin for Auth0 `redirect_uri` and post-login URL
 * sanitization. Prefers the host the user is actually browsing so ephemeral
 * proxy URLs (`ephemeral.pilot.petsmart.com/?ticket=...`) are used instead of
 * the build-time `NEXT_PUBLIC_ORIGIN` vercel.app deployment URL.
 */
export function getAuth0RedirectOrigin(): string {
    const browserOrigin = getOrigin();

    if (browserOrigin) {
        return browserOrigin;
    }

    return getENV('NEXT_PUBLIC_ORIGIN');
}
